import React, { Suspense, useState, useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import CssBaseline from "@material-ui/core/CssBaseline";
import { makeStyles } from "@material-ui/core/styles";
import AuthContext from "../hooks/authContext";
import CommonContext from "../hooks/commonContext";

// Required: BlankLayouts redirects authenticated users to /dashboard by default.
// Email verify, password reset, and handler links must still render when a session
// exists (e.g. user logged in elsewhere and opens the link in the same browser).
const AUTH_ACTION_FLOW_ROUTES = new Set([
  "/firebase-action-handler",
  "/verify-email",
  "/verify-new-email",
  "/verify-email-sent",
  "/thank-you",
  "/updatepassword",
  "/complete-registration",
]);

const useStyles = makeStyles((theme) => ({
  root: {
    display: "block",
  },
}));

const BlankLayouts = (props) => {
  const auth = useContext(AuthContext);
  const location = useLocation();
  const [layoutLoader, setLayoutLoader] = useState(false);
  const classes = useStyles();
  const isAuthActionFlow = AUTH_ACTION_FLOW_ROUTES.has(location.pathname);
  return (
    <>
      {auth?.status === true && !isAuthActionFlow && (
        <Navigate to="/dashboard" />
      )}
      {/* <CommonContext.Provider
        value={{
          loader: layoutLoader,
          setLoader: setLayoutLoader,
        }}
      > */}
          {/* {layoutLoader === true && <Loader />} */}
        <div className={`BlankContainer `}>
          <div className={classes.root} style={{ position: "relative" }}>
            <CssBaseline />
            <Suspense fallback={<div className="min-h-[40vh] w-full" aria-hidden />}>{props.children}</Suspense>
          </div>
        </div>
      {/* </CommonContext.Provider> */}
    </>
  );
};

export default BlankLayouts;
